'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncValidator = undefined;
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
var asyncValidator = exports.asyncValidator = function () {
  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(validators, value, values) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, validator, result, error;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 3;
            _iterator = validators[Symbol.iterator]();
          case 5:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 21;
              break;
            }
            validator = _step.value;
            result = validator(value, values);
            if (!(typeof result === 'function')) {
              _context.next = 16;
              break;
            }
            _context.next = 11;
            return result();
          case 11:
            error = _context.sent;
            if (!error) {
              _context.next = 14;
              break;
            }
            return _context.abrupt('return', error);
          case 14:
            _context.next = 18;
            break;
          case 16:
            if (!result) {
              _context.next = 18;
              break;
            }
            return _context.abrupt('return', result);
          case 18:
            _iteratorNormalCompletion = true;
            _context.next = 5;
            break;
          case 21:
            _context.next = 27;
            break;
          case 23:
            _context.prev = 23;
            _context.t0 = _context['catch'](3);
            _didIteratorError = true;
            _iteratorError = _context.t0;
          case 27:
            _context.prev = 27;
            _context.prev = 28;
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          case 30:
            _context.prev = 30;
            if (!_didIteratorError) {
              _context.next = 33;
              break;
            }
            throw _iteratorError;
          case 33:
            return _context.finish(30);
          case 34:
            return _context.finish(27);
          case 35:
            return _context.abrupt('return', '');
          case 36:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[3, 23, 27, 35], [28,, 30, 34]]);
  }));
  return function asyncValidator(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function (value, values) {
    var _loop = function _loop(i) {
      var validator = validators[i](value, values);
      if (typeof validator === 'function') {
        return {
          v: function v() {
            return asyncValidator(validators.slice(i), value, values);
          }
        };
      }
      if (validator) return {
        v: validator
      }; // the error message
    };
    for (var i = 0; i < validators.length; i++) {
      var _ret = _loop(i);
      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
    return '';
  };
};